  <div class="bg">
  <fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{settingName ? 'Update ': 'Add new '}} page</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="settingForm">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field style="width: 100%; margin-bottom: 16px;" appearance="outline">
              <mat-label>Select Page</mat-label>
              <mat-select formControlName="pageName" [disabled]="settingName ? true : false" (ngModelChange)="validatePromotionTimerField($event)">
                <mat-option *ngFor="let page of pageName" [value]="page?.value"> {{page?.name}}</mat-option>
              </mat-select>
              <mat-error
                *ngIf="settingForm.controls['pageName'].touched && settingForm.controls['pageName'].hasError('required')">
                This is a required field.
              </mat-error>
            </mat-form-field>
            <div style="display: flex; flex-wrap: wrap;">
              <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
              style="margin-bottom: 20px;align-items: baseline;">
              <div class="flex">
                <div class="innerdiv">
                  <div class="uploadsec" style="margin-right: 20px">
                    <div class="imgsec">
                      <img [src]="bannerImage ?  bannerImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image">
                      <span (click)="removeBadge('badge')" *ngIf="bannerImage" class="removebadge"><mat-icon>close</mat-icon></span> 
                    </div>
                    <div class="uploadbtnsec">
                      <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                        style="display:none">
                      <button type="button" class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload dynamic badge</button>
                    </div>
                  </div>
                </div>
              </div>
              </fxLayout>
              <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
              style="margin-bottom: 20px;align-items: baseline;">
              <div class="flex">
                <div class="innerdiv">
                  <div class="uploadsec" style="margin-right: 20px">
                    <div class="imgsec">
                      <img [src]="otherBadgeImage ?  otherBadgeImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image">
                      <span (click)="removeOtherBadge('otherBadge')" *ngIf="otherBadgeImage" class="removebadge"><mat-icon>close</mat-icon></span>  
                    </div>
                    <div class="uploadbtnsec">
                      <input type="file" #image_two (change)="otherBadgeImageUpload($event)" accept=".png, .jpg, .jpeg"
                        style="display:none">
                      <button type="button" class="uploadfilebtn" mat-raised-button (click)="image_two.click()">Upload static badge</button>
                    </div>
                  </div>
                </div>
              </div>
              </fxLayout>
            </div>
            <mat-form-field style="width: 100%; margin-bottom: 16px;" appearance="outline" *ngIf="this.settingForm.controls['pageName'].value !== 'popUp'">
              <mat-label>Page Text</mat-label>
              <input matInput placeholder="Page Text" formControlName="bannerText">
              <mat-error *ngIf="settingForm.controls['bannerText'].touched && settingForm.controls['bannerText'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>Heading</mat-label>
              <textarea type="text" matInput placeholder="Heading" formControlName="heading"> </textarea>
              <mat-error *ngIf="settingForm.controls['heading'].touched && settingForm.controls['heading'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <div *ngIf="this.settingForm.controls['pageName'].value === 'offer' || this.settingForm.controls['pageName'].value === 'home' || this.settingForm.controls['pageName'].value === 'home' || this.settingForm.controls['pageName'].value === 'popUp'">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Sub Heading</mat-label>
                <textarea type="text" matInput placeholder="Sub heading" formControlName="subHeading"> </textarea>
                <mat-error *ngIf="settingForm.controls['subHeading'].touched && settingForm.controls['subHeading'].hasError('required')">
                    This is a required field.</mat-error>
              </mat-form-field>
            </div>
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>Content</mat-label>
              <textarea type="text" matInput placeholder="Content" formControlName="content"> </textarea>
              <mat-error *ngIf="settingForm.controls['content'].touched && settingForm.controls['content'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <div *ngIf="this.settingForm.controls['pageName'].value === 'popUp'">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Mobile Title</mat-label>
                <textarea type="text" matInput placeholder="Mobile Title" formControlName="mobileTitle"> </textarea>
                <mat-error *ngIf="settingForm.controls['mobileTitle'].touched && settingForm.controls['mobileTitle'].hasError('required')">
                    This is a required field.
                </mat-error>
              </mat-form-field>
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Mobile Description</mat-label>
                <textarea type="text" matInput placeholder="Mobile Description" formControlName="mobileDescription"> </textarea>
                <mat-error *ngIf="settingForm.controls['mobileDescription'].touched && settingForm.controls['mobileDescription'].hasError('required')">
                    This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
  
          <div *ngIf="this.settingForm.controls['pageName'].value === 'offer' || this.settingForm.controls['pageName'].value === 'home' || this.settingForm.controls['pageName'].value === 'home' || this.settingForm.controls['pageName'].value === 'popUp'">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>30-Day Free Trial</mat-label>
              <textarea type="text" matInput placeholder="Low Price Guarantee" formControlName="lowPriceGuarantee"> </textarea>
              <mat-error *ngIf="settingForm.controls['lowPriceGuarantee'].touched && settingForm.controls['lowPriceGuarantee'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
  
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>Money Back Guarantee</mat-label>
              <textarea type="text" matInput placeholder="Money Back Guarantee" formControlName="moneyBackGuarantee"> </textarea>
              <mat-error *ngIf="settingForm.controls['moneyBackGuarantee'].touched && settingForm.controls['moneyBackGuarantee'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
          </div>
          <fxLayout fxLayout="column" fxLayoutGap.gt-sm="24px" style="margin-bottom: 20px; width: 100% !important;">              
              <mat-label>Promotion Banner Text</mat-label>
              <ckeditor [config]="editorConfig" formControlName="promotionBannerText" debounce="500"></ckeditor>
              <mat-error *ngIf="settingForm.controls['promotionBannerText'].touched && settingForm.controls['promotionBannerText'].hasError('required')">
                  This is a required field.
              </mat-error>
          </fxLayout>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Promotion Text</mat-label>
            <textarea type="text" matInput placeholder="Promotion Text" formControlName="promotionText"> </textarea>
            <mat-error *ngIf="settingForm.controls['promotionText'].touched && settingForm.controls['promotionText'].hasError('required')">
                This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Unit Number Explanation Text</mat-label>
            <input matInput placeholder="Unit Number Explanation Text" formControlName="unitNumberText">
            <mat-error *ngIf="settingForm.controls['unitNumberText'].touched && settingForm.controls['unitNumberText'].hasError('required')">
                This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Property Information Explanation Text</mat-label>
            <input matInput placeholder="Property Information Explanation Text" formControlName="propertyInformationText">
            <mat-error *ngIf="settingForm.controls['propertyInformationText'].touched && settingForm.controls['propertyInformationText'].hasError('required')">
                This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{settingName === 'estimate' ? 'Address' : 'First Name And Last Name'}} Explanation Text</mat-label>
            <input matInput [placeholder]="settingName === 'estimate' ? 'Address Explanation Text' : 'First Name And Last Name Explanation Text'" formControlName="formFirstStepText">
            <mat-error *ngIf="settingForm.controls['formFirstStepText'].touched && settingForm.controls['formFirstStepText'].hasError('required')">
                This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{settingName === 'estimate' ? 'Final Step' : 'Phone And Email'}} Explanation Text</mat-label>
            <input matInput [placeholder]=" settingName === 'estimate' ? 'Final Step Explanation Text' : 'Phone And Email Explanation Text'" formControlName="formSecondStepText">
            <mat-error *ngIf="settingForm.controls['formSecondStepText'].touched && settingForm.controls['formSecondStepText'].hasError('required')">
                This is a required field.</mat-error>
          </mat-form-field>
          <div class="timeDuration" *ngIf="this.settingForm.controls['pageName'].value !== 'popUp'">
            <h3>Promotion Duration</h3>

            <div class="promotion_panel">
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Days</mat-label>
                  <input type="number" matInput placeholder="Days" formControlName="startingPromotionDays" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['startingPromotionDays'].touched && settingForm.controls['startingPromotionDays'].hasError('required')">
                      This is a required field.</mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Hour</mat-label>
                  <input type="number" matInput placeholder="Hour" formControlName="startingPromotionHours" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['startingPromotionHours'].touched && settingForm.controls['startingPromotionHours'].hasError('required')">
                      This is a required field.</mat-error>
                      <mat-error *ngIf="settingForm.controls['startingPromotionHours'].touched && settingForm.controls['startingPromotionHours'].hasError('min')">
                        Minimum Value should be 0.
                      </mat-error>
                    <mat-error *ngIf="settingForm.controls['startingPromotionHours'].touched && settingForm.controls['startingPromotionHours'].hasError('max')">
                      Maximum Value should be 23.
                    </mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Minutes</mat-label>
                  <input type="number" matInput placeholder="Minutes" formControlName="startingPromotionMinutes" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['startingPromotionMinutes'].touched && settingForm.controls['startingPromotionMinutes'].hasError('required')">
                      This is a required field.</mat-error>
                      <mat-error *ngIf="settingForm.controls['startingPromotionMinutes'].touched && settingForm.controls['startingPromotionMinutes'].hasError('min')">
                        Minimum Value should be 0.
                      </mat-error>
                    <mat-error *ngIf="settingForm.controls['startingPromotionMinutes'].touched && settingForm.controls['startingPromotionMinutes'].hasError('max')">
                      Maximum Value should be 59.
                    </mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Seconds</mat-label>
                  <input type="number" matInput placeholder="Seconds" formControlName="startingPromotionSeconds" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['startingPromotionSeconds'].touched && settingForm.controls['startingPromotionSeconds'].hasError('required')">
                      This is a required field.
                  </mat-error>
                  <mat-error *ngIf="settingForm.controls['startingPromotionSeconds'].touched && settingForm.controls['startingPromotionSeconds'].hasError('min')">
                    Minimum Value should be 0.
                  </mat-error>
                <mat-error *ngIf="settingForm.controls['startingPromotionSeconds'].touched && settingForm.controls['startingPromotionSeconds'].hasError('max')">
                  Maximum Value should be 59.
                </mat-error>
                </mat-form-field>
              </span>
            </div>
            
            
            
            
            
          </div>

          <div class="timeDuration" *ngIf="this.settingForm.controls['pageName'].value !== 'popUp'">
            <h3>Reset promotion after</h3>
            <div class="promotion_panel">
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Days</mat-label>
                  <input type="number" matInput placeholder="Days" formControlName="endingPromotionDays" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['endingPromotionDays'].touched && settingForm.controls['endingPromotionDays'].hasError('required')">
                      This is a required field.</mat-error>
                      <mat-error *ngIf="settingForm.controls['endingPromotionDays'].hasError('notValid')">
                        Ending day should be greater than starting day.
                      </mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Hour</mat-label>
                  <input type="number" matInput placeholder="Hour" formControlName="endingPromotionHours" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['endingPromotionHours'].touched && settingForm.controls['endingPromotionHours'].hasError('required')">
                      This is a required field.</mat-error>
                      <mat-error *ngIf="settingForm.controls['endingPromotionHours'].touched && settingForm.controls['endingPromotionHours'].hasError('min')">
                        Minimum Value should be 0.
                      </mat-error>
                    <mat-error *ngIf="settingForm.controls['endingPromotionHours'].touched && settingForm.controls['endingPromotionHours'].hasError('max')">
                      Maximum Value should be 23.
                    </mat-error>
                    <mat-error *ngIf="settingForm.controls['endingPromotionHours'].hasError('notValid')">
                      Ending hour should be greater than starting hour.
                    </mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Minutes</mat-label>
                  <input type="number" matInput placeholder="Minutes" formControlName="endingPromotionMinutes" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['endingPromotionMinutes'].touched && settingForm.controls['endingPromotionMinutes'].hasError('required')">
                      This is a required field.</mat-error>
                      <mat-error *ngIf="settingForm.controls['endingPromotionMinutes'].touched && settingForm.controls['endingPromotionMinutes'].hasError('min')">
                        Minimum Value should be 0.
                      </mat-error>
                    <mat-error *ngIf="settingForm.controls['endingPromotionMinutes'].touched && settingForm.controls['endingPromotionMinutes'].hasError('max')">
                      Maximum Value should be 59.
                    </mat-error>
                    <mat-error *ngIf="settingForm.controls['endingPromotionMinutes'].hasError('notValid')">
                      Ending minute should be greater than starting minute.
                    </mat-error>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Seconds</mat-label>
                  <input type="number" matInput placeholder="Seconds" formControlName="endingPromotionSeconds" (keypress)="api.allowNumbers($event)">
                  <mat-error *ngIf="settingForm.controls['endingPromotionSeconds'].touched && settingForm.controls['endingPromotionSeconds'].hasError('required')">
                      This is a required field.
                  </mat-error>
                  <mat-error *ngIf="settingForm.controls['endingPromotionSeconds'].touched && settingForm.controls['endingPromotionSeconds'].hasError('min')">
                    Minimum Value should be 0.
                  </mat-error>
                <mat-error *ngIf="settingForm.controls['endingPromotionSeconds'].touched && settingForm.controls['endingPromotionSeconds'].hasError('max')">
                  Maximum Value should be 59.
                </mat-error>
                <mat-error *ngIf="settingForm.controls['endingPromotionSeconds'].hasError('notValid')">
                  Ending second should be greater than starting second.
                </mat-error>
                </mat-form-field>
              </span>
            </div>
          </div>
          
          <div  *ngIf="this.settingForm.controls['pageName'].value !== 'popUp'">
            <mat-checkbox class="example-margin" formControlName="resetPromotion">Reset Promotion</mat-checkbox>
          </div>
  
            <mat-form-field style="width: 100%; margin-bottom: 16px;" appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select formControlName="isActive">
                <mat-option [value]="1"> Active </mat-option>
                <mat-option [value]="0"> Inactive </mat-option>
  
              </mat-select>
              <mat-error
                *ngIf="settingForm.controls['isActive'].touched && settingForm.controls['isActive'].hasError('required')">
                This is a required field.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="save()"><span>{{settingName ? 'Update' : 'Add'}}</span></button>
          </div>
  
           
          </form>
    </div>
  </div>
  </div>